import React, { useEffect, useState } from "react";
import "./AddCoachForm.css";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Box, Checkbox, MenuItem, Typography } from "@mui/material";
import TextArea from "../../../Atoms/Inputs/TextArea/TextArea";
import useEdit from "../../../../Hooks/useEdit";
import useSave from "../../../../Hooks/useSave";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import { Formik } from "formik";
import * as Yup from "yup";
import { PhoneInput } from "react-international-phone";
import { MuiTelInput } from "mui-tel-input";
import { phone } from "phone";
import "react-international-phone/style.css";
import config from "../../../../config";

const CoachSchema = Yup.object().shape({
  name: Yup.string().required("Coach Name is required!"),
});

function AddCoachForm({
  Edit = false,
  team,
  url,
  coach,
  satCoach,
  setOpen,
  page,
  search,
  navigateafter = true,
  setCoaches,
  editId,
  setCoachesUpdate,
}) {
  const [Phone, setPhone] = useState("");
  const [PhoneError, setPhoneError] = useState(null);
  const [PhoneTouched, setPhoneTouched] = useState(false);
  const [newObject, setNewObject] = useState({});
  const [goEdit, setGoEdit] = useState(false);
  const [goSave, setGoSave] = useState(false);
  const { state, loading: editLoading } = useEdit(
    `${url}/${editId}`,
    goEdit,
    setGoEdit,
    newObject,
    -1
  );
  const {
    saveState,
    loading: addLoading,
    newData,
  } = useSave({
    url: url,
    goSave,
    setGoSave,
    newObject,
    navigateAfter: navigateafter ? "/coaches" : null,
  });

  useEffect(() => {
    if (
      !phone(Phone)?.isValid ||
      (Phone?.length < 13 && phone(Phone)?.countryCode == "+20")
    )
      setPhoneError("Valid Phone Number Required!!");
    else setPhoneError("");
  }, [Phone]);

  useEffect(() => {
    if (coach) {
      setPhone(coach?.contactNumber);
    }
  }, [coach]);

  // useEffect(() => {
  //   if (newData && !saveState.loadingRes && !newData.loading)
  //     setCoaches(newData?.data?.data);
  // }, [newData]);

  // useEffect(() => {
  //   if (state.dataRes.status == "success") {
  //     setOpen(false);
  //   }
  // }, [state]);

  useEffect(() => {
    if (saveState.dataRes.status == "success" && !navigateafter) {
      setOpen(false);
      setCoachesUpdate(false);
    }
  }, [saveState]);

  return (
    <div className="SmallFormWrapper">
      <Formik
        initialValues={{
          name: coach?.name ?? "",
        }}
        validationSchema={CoachSchema}
        onSubmit={(values) => {
          if (!PhoneError)
            if (coach) {
              const prev = {
                name: coach?.name ?? "",
                contactNumber: coach?.contactNumber ?? "",
              };
              setNewObject(
                Object.fromEntries(
                  Object.entries({
                    ...prev,
                    ...values,
                    contactNumber: Phone,
                  }).filter(([key]) => prev[key] != values[key])
                )
              );
              setGoEdit(true);
            } else {
              setNewObject({
                ...values,
                contactNumber: Phone,
              });
              setGoSave(true);
            }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="FormContainer" style={{ flexDirection: "column" }}>
              <div>
                <TextFieldInput
                  fullWidth
                  type="text"
                  placeholder={"Enter Coach's Name"}
                  className="Input"
                  label={"Coach's Name"}
                  name={"name"}
                  change={handleChange}
                  blur={handleBlur}
                  newValue={values.name}
                />
                {errors.name && touched.name && (
                  <p className="error">{errors.name}</p>
                )}
              </div>

              <div style={{ position: "relative" }}>
                <label className="labelPhone">Coach Phone Number *</label>
                <PhoneInput
                  label={"Coach Phone Number"}
                  className="textfield Input phoneInput"
                  value={Phone}
                  defaultCountry="eg"
                  onChange={(e) => {
                    setPhone(e);
                  }}
                />
                {PhoneError && PhoneTouched ? (
                  <p className="error">{PhoneError}</p>
                ) : (
                  ""
                )}
              </div>
              {/* <div>
                <TextFieldInput
                  fullWidth
                  name="email"
                  type="email"
                  placeholder={"Enter Coach's Email"}
                  className="Input"
                  label="Coach's Email"
                  change={handleChange}
                  blur={handleBlur}
                  newValue={values?.email}
                />
                {errors.email && touched.email && (
                  <p className="error">{errors.email}</p>
                )}
              </div> */}
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <PrimaryButton
                classBtn={"center"}
                btnType={"submit"}
                text={Edit ? "Edit" : "Add"}
                loading={Edit ? editLoading : addLoading}
                click={() => {
                  setPhoneTouched(true);
                  handleSubmit();
                }}
                style={{
                  textTransform: "capitalize",
                  marginTop: "10px",
                  width: "160px",
                  borderRadius: "5px",
                  color: config.SECONDARY_COLOR,
                  backgroundColor: config.PRIMARY_COLOR,
                }}
              />
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default AddCoachForm;
